//定义公共方法

//循环获取下拉框数据，获取需要的数据（参数，list，唯一标识）
function getItemKey(value, list, itemKey) {
  const item = list.find(item => item[itemKey] === value)
  return item ? item : ''
}

//遍历树形数据，删除其空child项
function deleteChild(arr) {
  let childs = arr
  for (let i = childs.length; i--; i > 0) {
    if (childs[i].child) {
      if (childs[i].child.length) {
        this.deleteChild(childs[i].child)
      } else {
        delete childs[i].child
      }
    }
  }
  return arr
}

function convertBase64UrlToBlob (base64) {
  let parts = base64.split(';base64,')
  let contentType = parts[0].split(':')[1]
  let raw = window.atob(parts[1])
  let rawLength = raw.length
  let uInt8Array = new Uint8Array(rawLength)
  for (let i = 0; i < rawLength; i++) {
    uInt8Array[i] = raw.charCodeAt(i)
  }
  return new Blob([uInt8Array], {type: contentType})
}

// 下载图片
function downloadFileByBlob (blobUrl, filename) {
  const eleLink = document.createElement('a')
  eleLink.download = filename
  eleLink.style.display = 'none'
  eleLink.href = blobUrl
  // 触发点击
  document.body.appendChild(eleLink)
  eleLink.click()
  // 然后移除
  document.body.removeChild(eleLink)
}
//抛出 定义的方法
export default {
  getItemKey,
  deleteChild,
  convertBase64UrlToBlob,
  downloadFileByBlob,
}
